import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import axios from "axios";
import "./Home.css";
import Slider from "react-slick";


const Home = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [formData, setFormData] = useState({ name: "", email: "", password: "", role: "" });
  const [user, setUser] = useState(null);
  const [showQR, setShowQR] = useState(false);
  const [activeAccount, setActiveAccount] = useState(null);
  const [freeVideos, setFreeVideos] = useState([]);
  const [videos, setVideos] = useState([]);

  const [step, setStep] = useState(1);
  const [buyFormData, setBuyFormData] = useState({
    name: "",
    email: "",
    phone: "",
    selectedPlan: "",
    transactionId: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    const storedAdmin = localStorage.getItem("adminUser");
    const storedCreator = localStorage.getItem("creatorUser");

    if (storedAdmin) setUser(JSON.parse(storedAdmin));
    else if (storedCreator) setUser(JSON.parse(storedCreator));


    // Fetch active payment account
    //  axios.get(`${process.env.REACT_APP_API_URL}/api/admin/payment/accounts`)
    // .then(res => {
    //   console.log(res.data); // <-- check the structure
    //   const accounts = res.data.accounts || [];
    //   const active = accounts.find(a => a.isActive);
    //   if (active) setActiveAccount(active);
    // })
    // .catch(err => {
    //   console.error("Error fetching accounts", err);
    // });
    axios.get(`${process.env.REACT_APP_API_URL}/api/admin/payment-accounts`)
      .then(res => {
        console.log("Full Response:", res);
        const accounts = Array.isArray(res.data) ? res.data : (res.data.accounts || []);
        const active = accounts.find(a => a.isActive);
        if (active) setActiveAccount(active);
      })
      .catch(err => {
        if (err.response) {
          console.error("Server responded with error:", err.response.status, err.response.data);
        } else if (err.request) {
          console.error("No response from server. Request was:", err.request);
        } else {
          console.error("Axios error:", err.message);
        }
      });
    // Fetch free videos
    const fetchVideos = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/videos/free`);

        // Safely extract videos from API response
        const videosArray = Array.isArray(res.data)
          ? res.data
          : res.data.videos || [];

        const videosWithPlayingFlag = videosArray.map((v) => ({
          ...v,
          playing: false,
        }));

        setFreeVideos(videosWithPlayingFlag);
      } catch (err) {
        console.error("Error fetching free videos: ", err);
      }
    };

    fetchVideos();

  }, []);

// YouTube latest videos
useEffect(() => {
    const fetchYoutubeVideos = async () => {
      try {
        const res = await axios.get("https://www.googleapis.com/youtube/v3/search", {
          params: {
            key: process.env.REACT_APP_YOUTUBE_API_KEY,
            channelId: process.env.REACT_APP_YOUTUBE_CHANNEL_ID,
            part: "snippet,id",
            order: "date",
            maxResults: 3,
          },
        });
        setVideos(res.data.items);
      } catch (err) {
        console.error("YouTube fetch error:", err);
      }
    };

    fetchYoutubeVideos();
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
  };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("Login formData:", formData);

    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, {
        email: formData.email,
        password: formData.password,
      });

      const user = res.data.user;

      if (user.role === "admin") {
        localStorage.setItem("adminUser", JSON.stringify(user));
        setUser(user);
        navigate("/admin");
      } else if (user.role === "creator") {
        localStorage.setItem("creatorUser", JSON.stringify(user));
        setUser(user);
        navigate("/creator");
      } else if (user.role === "paid") {
        localStorage.setItem("paidUser", JSON.stringify(user));
        setUser(user);
        navigate("/user-dashboard");
      } else {
        alert("Invalid role.");
      }
    } catch (err) {
      console.error("Login error:", err.response?.data || err.message);
      alert("Login failed. Please check credentials.");
    }
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/register`, {
        name: formData.name,
        email: formData.email,
        password: formData.password,
        role: formData.role,
      });

      alert("Signup successful. Please login.");
      setShowSignup(false);
      setShowLogin(true);
      setFormData({ name: "", email: "", password: "", role: "" });
    } catch (err) {
      console.error("Signup failed:", err.response?.data || err.message);
      alert("Signup failed. Email may already exist.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("adminUser");
    localStorage.removeItem("creatorUser");
    localStorage.removeItem("paidUser");
    setUser(null);
    navigate("/");
  };


  const handleBuyNow = (plan) => {
    setBuyFormData({
      name: "",
      email: "",
      phone: "",
      selectedPlan: plan,
      transactionId: "",
    });
    setStep(1);
    setShowQR(true);
  };

  // const handleBuySubmit = () => {
  //   console.log("Transaction submitted:", buyFormData);
  //   alert("Transaction submitted! We will verify and activate your plan.");
  //   setShowQR(false);
  // };

  const handleBuySubmit = async () => {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/invoice`, buyFormData);
      alert("Transaction submitted! Invoice sent to your email.");
      setShowQR(false);
    } catch (err) {
      console.error("Invoice send failed", err);
      alert("Transaction saved, but failed to send invoice.");
    }
  };

  const playerRef = useRef(null);

  const videoIds = [
    "2yJmrACbwZY",
    "UV5FORkLDf8",
    "g44Xjw35Ex0"
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  // YouTube Slideshow Autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % videoIds.length);
    }, 15000); // 15 seconds

    return () => clearInterval(interval);
  }, []);



  return (
    <div className="homepage-container">
      <header className="home-header">
        <div class="home-logo"><img src="https://nitinshukla.in/wp-content/uploads/2024/03/channels4_profile.jpg"></img><h1>Nitinshukla</h1></div>


        <div>
          {user ? (
            <>
              <span>Welcome, {user.email}</span>
              <button onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <>
              {/* <a href="/free-videos"><button>Free Videos</button></a> */}
              <button onClick={() => { setShowLogin(true); setShowSignup(false); }}>Login</button>
              <button onClick={() => { setShowSignup(true); setShowLogin(false); }}>Signup</button>
            </>
          )}
        </div>
        <div className="social-links">
          <a href="http://instagram.com/nshuklain">
            {/* <img src="https://ouch-prod-var-cdn.icons8.com/jh/illustrations/previews/mfzgWn_DVb368-6D.webp"></img> */}
            <i class="fa fa-instagram"></i>
          </a>
          <a href="https://www.youtube.com/NitinShukla">
            {/* <img src="https://png.pngtree.com/png-clipart/20221018/ourmid/pngtree-youtube-social-media-3d-stereo-png-image_6308427.png"></img> */}
            <i class="fa fa-youtube-play"></i>
          </a>
          <a href="http://facebook.com/NitinShuklaIn">
            {/* <img src="https://cdn3d.iconscout.com/3d/free/thumb/free-facebook-7096215-5753419.png?f=webp"></img> */}
            <i class="fa fa-facebook-square"></i>
          </a>
          <a href="https://x.com/nshuklain">
            {/* <img src="https://static.vecteezy.com/system/resources/previews/029/129/369/non_2x/x-3d-icon-free-png.png"></img> */}
            <i class="fa fa-twitter-square"></i>
          </a>
          <a href="http://t.me/nshuklain">
            {/* <img src="https://ouch-prod-var-cdn.icons8.com/md/illustrations/previews/eTP4IsfUMTXJD20d.webp"></img> */}
            <i class="fa fa-telegram"></i>
          </a>
          <a href="https://whatsapp.com/channel/0029Va9MicX0G0Xgz9xZAl2m">
            {/* <img src="https://ouch-prod-var-cdn.icons8.com/dj/illustrations/previews/V9v8ZSeJ-e1XyzdZ.webp"></img> */}
            <i class="fa fa-whatsapp"></i>
          </a>
          <a href="https://www.patreon.com/NitinShukla">
            {/* <img src="https://nitinshukla.in/wp-content/uploads/2025/01/WhatsApp-Image-2025-01-09-at-15.31.15_096d5ce1-1-1536x1536.jpg"></img> */}
            <i class="fa fa-product-hunt"></i>
          </a>
          <a href="https://www.paypal.com/paypalme/NitinShuklaGwl">
            {/* <img src="https://cdn3d.iconscout.com/3d/premium/thumb/paypal-12119000-9863303.png"></img> */}
            <i class="fa fa-paypal"></i>
          </a>
        </div>
      </header>

      {/* Login Modal */}
      {showLogin && (
        <div className="modal-overlay" onClick={() => setShowLogin(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <form className="login-form" onSubmit={handleLogin}>
              <h3>Login</h3>
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
              <button type="submit">Login</button>
              <p>
                Don’t have an account?{" "}
                <span
                  className="form-switch"
                  onClick={() => {
                    setShowLogin(false);
                    setShowSignup(true);
                  }}
                >
                  Signup
                </span>
              </p>
            </form>
          </div>
        </div>
      )}

      {/* Signup Modal */}
      {showSignup && (
        <div className="modal-overlay" onClick={() => setShowSignup(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <form className="login-form" onSubmit={handleSignup}>
              <h3>Signup</h3>
              <input type="text" name="name" placeholder="Name" value={formData.name} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              <input type="password" name="password" placeholder="Password" value={formData.password} onChange={handleChange} required />
              <select name="role" value={formData.role} onChange={handleChange} required>
                <option value="">Select Role</option>
                <option value="creator">Creator</option>
                <option value="paid">Paid Viewer</option>
              </select>
              <button type="submit">Register</button>
              <p>
                Already have an account?{" "}
                <span
                  className="form-switch"
                  onClick={() => {
                    setShowSignup(false);
                    setShowLogin(true);
                  }}
                >
                  Login
                </span>
              </p>
            </form>
          </div>
        </div>
      )}


      {/* <section className="home-hero">
        <h2>Welcome to Your Data Subscription Platform</h2>
        <p>Access subscription-based leasing data securely and quickly.</p>
      </section> */}
      <section className="hero-video-section">
        {/* Background video */}
        {/* <video
          autoPlay
          loop
          muted
          playsInline
          className="hero-background-video"
        >
          <source src="https://videos.pexels.com/video-files/5453622/5453622-uhd_2560_1440_24fps.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}

        {/* Blur overlay */}
        {/* <div className="hero-blur-overlay"></div> */}

        {/* Content overlay */}
        <div className="hero-overlay-content">
          {/* <div className="inline-flex items-center space-x-2 mb-6">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
            <span className="text-stream-text-muted text-sm">StreamFlow</span>
          </div> */}

          {/* <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6">
            <span className="text-foreground">Discover</span><br />
            <span className="text-foreground">Endless</span><br />
            <span className="bg-stream-gradient bg-clip-text text-transparent">
              Video Content
            </span>
          </h1> */}


        </div>
        {/* <div className="youtube-slideshow">
          <iframe
            ref={playerRef}

            title="YouTube Slideshow"
            src={`https://www.youtube.com/embed/${videoIds[currentIndex]}?autoplay=0&mute=1&controls=0`}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          ></iframe>
        </div> */}
        <section className="youtube-banner">
      
      {videos.length > 0 ? (
        <Slider {...settings}>
          {videos.map((video) => (
            <div key={video.id.videoId} className="slide">
              <a
                href={`https://www.youtube.com/watch?v=${video.id.videoId}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={video.snippet.thumbnails.high.url}
                  alt={video.snippet.title}
                  style={{ width: "100%" }}
                />
                {/* <h3 style={{ marginTop: "10px", textAlign: "center" }}>
                  {video.snippet.title}
                </h3> */}
              </a>
            </div>
          ))}
        </Slider>
      ) : (
        <p>Loading latest videos...</p>
      )}
    </section>

      </section>
      <section class="about-section">
        <div class="about">
          <div class="about-inner">
            <img src="https://img.freepik.com/free-vector/photo-video-isometric-with-conceptual-online-tv-studio-smartphone-screen-with-people-elements-vector-illustration_1284-29975.jpg?t=st=1754643216~exp=1754646816~hmac=eb9e957fd365c20d223682058ea921c749f9ad9166cca570629787bfc4ad1e93&w=1480"></img>
            <div><h2>About Me</h2>
              <p className="text-stream-text-muted text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
                Nitin Shukla is a multifaceted Indian thought leader—an analyst, journalist, author, motivational speaker, mentor, life coach, and business trainer. <br></br>On his YouTube channel, he delivers insightful commentary on world news, societal issues, leadership, and personal empowerment, with a subscriber base of around 357K and 1.04k videos created so far.
                <br></br> This platform offers curated subscription plans, interactive calling minutes, and message plans (text and WhatsApp), a structured membership model for followers.
              </p>
              <a href="#pricing"><button>See Our Plans</button></a>
            </div>


          </div>
        </div>
      </section>
      <section class="offer-section">
        <h2>What Does He Offer?</h2>
        <div class="cards-container">
          <div class="card">
            <h3>Digital Content & Community</h3>
            <p>Daily videos, cultural commentary, motivational insights.</p>
          </div>
          <div class="card">
            <h3>Exclusive Plans</h3>
            <p>
              Exclusive content, interactive calling minutes, and WhatsApp/message plans via
              <a href="https://nitinshukla.com" target="_blank" rel="noopener noreferrer"> nitinshukla.com</a>.
            </p>
          </div>
          <div class="card">
            <h3>Coaching & Mentorship</h3>
            <p>Growth-focused programs for professionals and emerging leaders.</p>
          </div>
          <div class="card">
            <h3>Speaking & Events</h3>
            <p>Keynote speaker at events like Surat Literary Festival; available for virtual & in-person events.</p>
          </div>
        </div>
      </section>



      {/* <section className="home-features">
        <div className="feature"><h3>Secure Payments</h3><p>Static QR payment and flexible subscriptions.</p></div>
        <div className="feature"><h3>Admin Dashboard</h3><p>Manage users, videos, and payment accounts easily.</p></div>
        <div className="feature"><h3>Full Control</h3><p>Flexible UPI configurations and member management.</p></div>
      </section> */}

      <section className="featured-videos-section">
        <div className="featured-videos">
          <div className="featured-header">
            <h2>Featured Free Videos</h2>
            <button className="view-all-btn" onClick={() => navigate("/free-videos")}>
              View All
            </button>
          </div>
          <div className="video-list">
            {freeVideos.length === 0 ? (
              <p>No free videos available.</p>
            ) : (
              freeVideos.slice(0, 4).map((video) => (
                <div key={video._id} className="video-card">
                  <h4>{video.title}</h4>
                  <div
                    className="video-thumbnail-wrapper"
                    onClick={() => {
                      setFreeVideos(freeVideos.map((v) =>
                        v._id === video._id ? { ...v, playing: true } : v
                      ));
                    }}
                  >
                    {!video.playing ? (
                      <>
                        <img
                          src={`${process.env.REACT_APP_API_URL}${video.thumbnail}`}
                          alt={video.title}
                          className="video-thumbnail"
                        />
                        <div className="play-button-overlay">▶️</div>
                      </>
                    ) : (
                      <video width="300" controls autoPlay muted>
                        <source
                          src={`${process.env.REACT_APP_API_URL}${video.videoUrl}`}
                          type="video/mp4"
                        />
                        Your browser does not support the video tag.
                      </video>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </section>



      <section className="pricing-section" id="pricing">
        <h2>Pricing Plans</h2>
        <div className="pricing-cards">
          <div className="card">
            <h3>Free Plan</h3>
            <p>₹0 / month</p>
            <ul><li>Access to free content</li></ul>
            <button disabled>Current</button>
          </div>
          <div className="card">
            <h3>Basic Plan</h3>
            <p>₹599 / month</p>
            <ul><li>1call 2mins /month </li><li> 5 whatsapp messages</li><li>Premium Videos</li></ul>
            <button onClick={() => handleBuyNow("Basic Plan")}>Buy Now</button>
          </div>
          <div className="card">
            <h3>Bronze Member Plan</h3>
            <p>₹999 / month</p>
            <ul><li>2call x 3mins /month </li><li> 15 whatsapp messages</li><li>Premium Videos</li></ul>
            <button onClick={() => handleBuyNow("Bronze Plan")}>Buy Now</button>
          </div>
          <div className="card">
            <h3>Silver Member Plan</h3>
            <p>₹2100 / month</p>
            <ul><li>5call x 5mins/month </li><li> 30 whatsapp messages</li><li>Premium Videos</li></ul>
            <button onClick={() => handleBuyNow("Silver Plan")}>Buy Now</button>
          </div>
          <div className="card">
            <h3>Gold Member Plan</h3>
            <p>₹5100 / month</p>
            <ul><li>15call x 5mins/month </li><li> 90 whatsapp messages</li><li>Premium Videos</li></ul>
            <button onClick={() => handleBuyNow("Gold Plan")}>Buy Now</button>
          </div>
          <div className="card">
            <h3>Platinum Member Plan</h3>
            <p>₹9999 / month</p>
            <ul><li>30call x 5mins/month </li><li> 150 whatsapp messages</li><li>Premium Videos</li></ul>
            <button onClick={() => handleBuyNow("Platinum Plan")}>Buy Now</button>
          </div>
          {/* <div className="card">
            <h3>Pro Plan</h3>
            <p>₹999 / month</p>
            <ul><li>All features unlocked</li><li>Priority support</li><li>Bonus content</li></ul>
            <button onClick={() => handleBuyNow("Pro Plan")}>Buy Now</button>
          </div> */}
        </div>
      </section>

      {/* Multistep Payment Popup */}
      {showQR && (
        <div className="qr-popup">
          <div className="qr-box">
            {step === 1 && (
              <>
                <h3>Step 1: Your Information</h3>
                <input
        type="text"
        placeholder="Name"
        value={buyFormData.name}
        onChange={(e) =>
          setBuyFormData({ ...buyFormData, name: e.target.value })
        }
      />

      <input
        type="email"
        placeholder="Email"
        value={buyFormData.email}
        onChange={(e) =>
          setBuyFormData({ ...buyFormData, email: e.target.value })
        }
      />

      {/* Phone Number Field */}
      <input
        type="tel"
        placeholder="Phone (10 digits)"
        value={buyFormData.phone}
        onChange={(e) => {
          // allow only numbers
          const value = e.target.value.replace(/\D/g, "");
          setBuyFormData({ ...buyFormData, phone: value });
        }}
        maxLength={10}
      />

      <p>
        <strong>Plan:</strong> {buyFormData.selectedPlan}
      </p>

      <button
        onClick={() => {
          // Validation logic
          const nameValid = buyFormData.name.trim().length > 0;
          const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(
            buyFormData.email
          );
          const phoneValid = /^\d{10}$/.test(buyFormData.phone);

          if (!nameValid) {
            alert("Please enter your name.");
            return;
          }
          if (!emailValid) {
            alert("Please enter a valid email (example: name@example.com).");
            return;
          }
          if (!phoneValid) {
            alert("Please enter a valid 10-digit phone number.");
            return;
          }

          setStep(2);
        }}
      >
        Next
      </button>
              </>
            )}

            {step === 2 && (
              <>
                <h3>Step 2: Make Payment</h3>
                {activeAccount ? (
                  <>
                    {activeAccount.type === "upi" ? (
                      <>
                        <p>
                          <strong>UPI ID:</strong> {activeAccount.upiId}
                        </p>
                        {activeAccount.qrCodeUrl ? (
                          <>
                            <img
                              src={`${process.env.REACT_APP_API_URL}${activeAccount.qrCodeUrl}`}
                              alt="QR Code"
                              width="200"
                            />
                            <p>Scan the QR code or use the UPI ID to pay.</p>
                          </>
                        ) : (
                          <p>No QR code provided.</p>
                        )}
                      </>
                    ) : (
                      <>
                        <p>
                          <strong>Bank Name:</strong> {activeAccount.bankName}
                        </p>
                        <p>
                          <strong>Account Number:</strong> {activeAccount.accountNumber}
                        </p>
                        <p>
                          <strong>IFSC:</strong> {activeAccount.ifsc}
                        </p>
                        <p>Use these details to complete a manual bank transfer.</p>
                      </>
                    )}
                    <button onClick={() => setStep(3)}>
                      I’ve paid → Enter Txn ID
                    </button>
                  </>
                ) : (
                  <p>No active payment account available.</p>
                )}
                <button onClick={() => setStep(1)}>Back</button>
              </>
            )}

            {step === 3 && (
              <>
                <h3>Step 3: Confirm Transaction</h3>
                <input
                  type="text"
                  placeholder="Transaction ID"
                  value={buyFormData.transactionId}
                  onChange={(e) =>
                    setBuyFormData({
                      ...buyFormData,
                      transactionId: e.target.value,
                    })
                  }
                />
                <button onClick={handleBuySubmit}>Submit</button>
                <button onClick={() => setStep(2)}>Back</button>
              </>
            )}


            <button className="close-btn" onClick={() => setShowQR(false)}>
              X
            </button>
          </div>
        </div>
      )}


      <section class="footer-home">
        <h6>© 2025 Nitin Shukla. All rights reserved.</h6>
        
      </section>

    </div>
  );
};

export default Home;
